import api from "@/modules/menu/services/menu-part.js";

const state = () => ({
    menuParts: [],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadMenuParts({commit}) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getMenuParts().then(result => {
            commit('SAVE_MENUPARTS', result.data);
            commit('SET_API_DATA_FETCH_SUCCESS')
        }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR', error)
        });
    },
    addMenuParts({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!payload) {
            return
        }
        api.postMenuPart(payload)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('ADD_MENUPART', r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION002', extra: 'niveau de menu' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'niveau de menu' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    updateMenuPart({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.putMenuPart(payload.id, payload)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('UPDATE_MENUPART', r.data);
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'niveau de menu' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'niveau de menu' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    deleteMenuPart({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteMenuPart(id)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('DELETE_MENUPART',id)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'niveau de menu' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'niveau de menu' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            })

    }
}

const mutations = {
    ADD_MENUPART (state, payload) {
        state.menuParts.push(payload)
    },
    UPDATE_MENUPART (state,payload){
        state.menuParts = state.menuParts.map(menupart => {
            if (menupart.id === payload.id) {
                return Object.assign({}, menupart, payload.data)
            }
            return menupart
        })
    },
    DELETE_MENUPART (state, id){
        const index = state.menuParts.findIndex(c => c.id == id);
        state.menuParts.splice(index, 1);
    },
    SAVE_MENUPARTS(state, menuParts) {
        state.menuParts = menuParts;
    },
    // Result api
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
